/** @format */

import { FunctionComponent as FC, useState } from 'react';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import styled from 'styled-components';
import SelectArrow from '../../../assets/icons/select-arrow.svg';
import { Error } from './Error';
import { FormControl } from './FormControl';

export const Select: FC<Props<FieldValues>> = ({
  name,
  label,
  register,
  errors,
  required,
  variant = 'light',
  children,
  onChange,
  onBlur,
}) => {
  const [value, setValue] = useState<string>('');

  const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const index = e.target.selectedIndex;
    setValue(e.target[index].textContent!);
    onChange && onChange(e);
    onBlur && onBlur(e);
  };

  return (
    <FormControl $filled={value !== ''} $variant={variant}>
      <label htmlFor={name} dangerouslySetInnerHTML={{ __html: label }} />
      <StyledSelect
        id={name}
        title={label}
        {...register(name, { required: required, onChange: e => onSelectChange(e), onBlur: e => onSelectChange(e) })}
        aria-invalid={errors[name] ? 'true' : 'false'}
      >
        {children}
      </StyledSelect>
      {/* TODO: Add error handling logic */}
      {errors[name] && <Error message={String(errors[name]?.message) ?? 'error'} />}
    </FormControl>
  );
};

type Props<T extends FieldValues> = {
  variant?: 'light' | 'dark';
  name: keyof T;
  label: string;
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
  required?: boolean | string;
  children: React.ReactNode;
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
  onBlur?: React.ChangeEventHandler<HTMLSelectElement>;
};

const StyledSelect = styled.select`
  z-index: 1;
  option:empty {
    display: none;
  }

  // #region CUSTOM ARROW

  --right: 0.94rem;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background: transparent;
  background-image: url(${SelectArrow});
  background-repeat: no-repeat;
  background-position-x: calc(100% - var(--right));
  background-position-y: 50%;

  // #endregion
`;
